import cp_onboarding from "../assests/images/globalSetting/cp-onboarding.svg";
import vehicle_onboarding from "../assests/images/globalSetting/vehicle-onboarding.svg";
import client_onboarding from "../assests/images/globalSetting/client-onboarding.svg";
import staff_onboarding from "../assests/images/globalSetting/staff-onboarding.svg";
import hub_onboarding from "../assests/images/globalSetting/hub-onboarding.svg";
import constants from "../constants/constants";

const { ROLES } = constants;
const { CP_ADMIN, HO_ADMIN, HUB_ADMIN } = ROLES;

export const globalParent = [
  {
    id: 1,
    imgSrc: staff_onboarding,
    title: "Staff Onboarding",
    route: "/staff-onboarding",
    disable: false,
    childPresent: false,
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN],
  },
  {
    id: 2,
    imgSrc: cp_onboarding,
    title: "CP Onboarding",
    route: "/cp-onbording",
    disable: false,
    childPresent: false,
    role: [HO_ADMIN],
  },
  {
    id: 3,
    imgSrc: vehicle_onboarding,
    title: "Vehicle Onboarding",
    route: "/vehicle-onboard",
    disable: false,
    childPresent: false,
    role: [CP_ADMIN, HUB_ADMIN],
  },
  {
    id: 4,
    imgSrc: client_onboarding,
    title: "Client Onboarding",
    route: "/client-onboarding",
    disable: false,
    childPresent: false,
    role: [CP_ADMIN],
  },
  {
    id: 5,
    imgSrc: hub_onboarding,
    title: "Hub Onboarding",
    route: "/hub-onboarding",
    disable: false,
    childPresent: false,
    role: [HO_ADMIN],
  },
  {
    id: 6,
    imgSrc: client_onboarding,
    title: "Client Approval",
    route: "/client-list",
    disable: false,
    childPresent: false,
    role: [HO_ADMIN],
  },
  // {
  //   id: 6,
  //   imgSrc: client_onboarding,
  //   title: "Middle mile",
  //   route: "/middle-mile",
  //   disable: false,
  //   childPresent: false,
  //   role: [HUB_ADMIN],
  // },
];
